import React, { useState,useEffect } from 'react';
import { Accordion,Placeholder } from 'react-bootstrap';
const DepartmentLabs = ({ pageData }) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[Labs,setLabs]=useState([]);
    useEffect(()=>
    {
        const LabsByDepartment = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"departmentLabs/labsByDepartment/"+pageData.sp_sd_id);
                const result = await response.json();
                setLabs(result);
                if( global.config.IsPrint === true ) { console.info('LabsByDepartment : Result',result); }
            } 
            catch (error) 
            {
                console.error('LabsByDepartment : Error', error.message);                
            }
            finally
            {
                setLoading(false);
            }
        };
        LabsByDepartment();
    },[pageData])
    return (
        <React.Fragment>
        {isLoading ? (
            <Accordion defaultActiveKey={[0]} alwaysOpen>
            {[...Array(12)].map((_,index)=>(
                <Accordion.Item eventKey={index} key={index}>
                    <Accordion.Header><Placeholder xs={6} /></Accordion.Header>
                    <Accordion.Body>
                        <Placeholder xs={12} />
                        <Placeholder xs={10} />
                        <Placeholder xs={8} />
                        <Placeholder xs={10} />
                        <Placeholder xs={6} />
                    </Accordion.Body>
                </Accordion.Item>
            ))}
            </Accordion>
            ) : (
            <Accordion defaultActiveKey={[0]} alwaysOpen>
            {Labs.map((dl,index)=>(
                <Accordion.Item eventKey={index} key={index}>
                    <Accordion.Header>
                        {appLanguage === 'hi' ? (dl.dl_display_en === "1" ? dl.dl_name_hi || '' : dl.dl_name_hi || dl.dl_name) : dl.dl_name}
                    </Accordion.Header>
                    <Accordion.Body dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? (dl.dl_display_en === "1" ? dl.dl_details_hi || '' : dl.dl_details_hi || dl.dl_details) : dl.dl_details}} ></Accordion.Body>
                </Accordion.Item>
            ))}
            </Accordion>
        )}
        </React.Fragment>
    );
}
export default DepartmentLabs;